// 登录
export function validatebyd(clause, e) {
    let validate = false;
    if (!clause) {
        validate = "请先勾选同意《用户授权协议》、《隐私条款》";
    } else if (e.username.length < 6) {
        validate = "账号字符不得低于6位"
    } else if (e.password.length < 6) {
        validate = "密码字符不得低于6位"
    }
    return validate;
}
// 手机号/验证码
export function validatephonereg(clause, e, id) {
    let validate = false;
    const phoneTest = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
    if (!clause) {
        validate = "请先勾选同意《用户授权协议》、《隐私条款》";
    } else if (e.phone.length < 11) {
        validate = "手机号字符不得低于11位";
    } else if (!phoneTest.test(e.phone)) {
        validate = "手机号格式错误"
    } else if (e.code.length < 4 && id == 1) {
        validate = "验证码字符不得低于4位";
    }
    return validate;
}
// 密码设置
export function validatenopwd(clause, e) {
    let validate = false;
    const passTest = /[a-zA-Z]+(?=\d+)|\d+(?=[a-zA-Z]+)/g;
    if (!clause) {
        validate = "请先勾选同意《用户授权协议》、《隐私条款》";
    } else if (e.password.length < 6) {
        validate = "密码不能小于六位"
    } else if (!passTest.test(e.password)) {
        validate = "密码格式为数字加字母"
    }
    return validate;
}
// 注册
export function validateregister(clause, e) {
    let validate = false;
    const userTest = /^[a-zA-Z]/;
    const passTest = /[a-zA-Z]+(?=\d+)|\d+(?=[a-zA-Z]+)/g;
    if (!clause) {
        validate = "请先勾选同意《用户授权协议》、《隐私条款》";
    } else if (e.username.length < 6) {
        validate = "账号字符不得低于6位"
    } else if (e.password.length < 6) {
        validate = "密码字符不得低于6位"
    } else if (!userTest.test(e.username)) {
        validate = "账号首位必须为字母，长度6-20位字符"
    } else if (!passTest.test(e.password)) {
        validate = "密码格式为数字加字母"
    } else if (e.password == e.username) {
        validate = "密码和账号不能相同"
    } else if (e.password != e.newpassword) {
        validate = "两次输入的密码请保持—致"
    }
    return validate;
}
// 重置
export function validatereset(e, id) {
    let validate = false;
    const passTest = /[a-zA-Z]+(?=\d+)|\d+(?=[a-zA-Z]+)/g;
    if (e.username.length < 6 && id == 1) {
        validate = "账号字符不得低于6位"
    } else if (e.code.length < 4 && id == 2) {
        validate = "验证码字符不得低于4位";
    } else if (e.password == e.username && id == 3) {
        validate = "密码和账号不能相同";
    } else if (e.password.length < 6 && id == 3) {
        validate = "密码字符不得低于6位";
    } else if (!passTest.test(e.password) && id == 3) {
        validate = "密码格式为数字加字母";
    } else if (e.password != e.newpassword && id == 3) {
        validate = "两次输入的密码不一致";
    }
    return validate;
}
// 手机号/验证码
export function validateuntie(e, id) {
    let validate = false;
    const phoneTest = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
    if (e.phone.length < 11) {
        validate = "手机号字符不得低于11位";
    } else if (!phoneTest.test(e.phone)) {
        validate = "手机号格式错误"
    } else if (e.code.length < 4 && id == 1) {
        validate = "验证码字符不得低于4位";
    }
    return validate;
}
// 登录后  手机号/验证码
export function validatephonecode(e, id) {
    let validate = false;
    const phoneTest = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
    if (e.phone.length < 11) {
        validate = "手机号字符不得低于11位";
    } else if (!phoneTest.test(e.phone)) {
        validate = "手机号格式错误"
    } else if (e.phone.slice(0, 4) != e.hintPhone.slice(0, 4)) {
        validate = "该手机号非账号绑定手机号, 请重新输入";
    } else if (e.code.length < 4 && id == 1) {
        validate = "验证码字符不得低于4位";
    }
    return validate;
}
// 登录后/重置
export function validateresetin(e) {
    let validate = false;
    const passTest = /[a-zA-Z]+(?=\d+)|\d+(?=[a-zA-Z]+)/g;
    if (e.password == e.username) {
        validate = "密码和账号不能相同";
    } else if (e.password.length < 6) {
        validate = "密码字符不得低于6位";
    } else if (!passTest.test(e.password)) {
        validate = "密码格式为数字加字母";
    } else if (e.password != e.newpassword) {
        validate = "两次输入的密码不一致";
    }
    return validate;
}
